import React from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import ChatDemo from './ChatDemo';
import { Chip, TelegramCta } from './primitives';
import { dotsBackground, landing } from './tokens';

const HeroSection: React.FC = () => {
  const { t } = useTranslation('landing');
  return (
    <Box
      component='section'
      id='topo'
      sx={{ ...dotsBackground, pt: { xs: 6, md: 9 }, pb: { xs: 8, md: 12 } }}
    >
      <Box
        sx={{
          maxWidth: landing.maxWidth,
          mx: 'auto',
          px: 3,
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: 7,
        }}
      >
        <Box
          sx={{
            flex: '1 1 460px',
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: 3,
          }}
        >
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            <Chip>
              <Box
                component='span'
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: landing.accent,
                }}
              />
              {t('hero.badgeTelegram')}
            </Chip>
            <Chip sx={{ borderStyle: 'dashed', color: landing.ink3 }}>
              {t('hero.badgeWhatsApp')}
            </Chip>
          </Box>
          <Box
            component='h1'
            sx={{
              fontSize: 'clamp(52px, 7vw, 92px)',
              lineHeight: 0.95,
              letterSpacing: '-0.04em',
              fontWeight: 750,
            }}
          >
            {t('hero.title')}
          </Box>
          <Box
            component='p'
            sx={{
              fontFamily: landing.display,
              fontSize: 'clamp(24px, 2.6vw, 32px)',
              lineHeight: 1.15,
              letterSpacing: '-0.015em',
              fontWeight: 500,
            }}
          >
            {t('hero.subtitle')}
          </Box>
          <Box
            component='p'
            sx={{
              fontSize: 18,
              lineHeight: 1.6,
              color: landing.ink2,
              maxWidth: 520,
            }}
          >
            {t('hero.description')}
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: 1.5,
              alignItems: 'center',
            }}
          >
            <TelegramCta
              label={t('hero.cta')}
              sx={{ boxShadow: landing.shadow }}
            />
            <Box
              component='a'
              href='#como-funciona'
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 54,
                px: 2.75,
                borderRadius: '999px',
                border: `1px solid ${landing.line}`,
                bgcolor: landing.surface,
                color: landing.ink,
                fontWeight: 600,
                fontSize: 16,
                textDecoration: 'none',
                '&:hover': { bgcolor: landing.bg2 },
              }}
            >
              {t('hero.secondary')}
            </Box>
          </Box>
          <Box component='p' sx={{ fontSize: 14, color: landing.ink3 }}>
            {t('hero.note')}
          </Box>
        </Box>

        <Box sx={{ flex: '1 1 400px', minWidth: 0 }}>
          <ChatDemo />
        </Box>
      </Box>
    </Box>
  );
};

export default HeroSection;
